import {useLocation} from 'react-router-dom'

export const usePDPSearchParams = (productId) => {
    const {search} = useLocation()

    const allParams = new URLSearchParams(search)
    const productParams = new URLSearchParams(allParams.get(productId) || '')

    return [allParams, productParams]
}
